import React from "react";
import LoginStepTwo from "../auth/LoginStepTwo";

const OptionsLoginStepTwo = () => {
  return <LoginStepTwo isFromOptions />;
};

export default OptionsLoginStepTwo;
